export type ExportTextDirection = 'auto' | 'ltr' | 'rtl'

export type DocumentExportSettings = {
  textDirection: ExportTextDirection
  fontSizePt: number
}

export const DEFAULT_DOCUMENT_EXPORT_SETTINGS: DocumentExportSettings = {
  textDirection: 'auto',
  fontSizePt: 12,
}

export const DOCUMENT_EXPORT_FONT_SIZE_OPTIONS = [
  10, 11, 12, 14, 16, 18, 20, 24,
]

export const normalizeDocumentExportSettings = (
  value: unknown,
): DocumentExportSettings => {
  if (!value || typeof value !== 'object') {
    return DEFAULT_DOCUMENT_EXPORT_SETTINGS
  }

  const maybeSettings = value as Partial<DocumentExportSettings>
  const textDirection: ExportTextDirection =
    maybeSettings.textDirection === 'ltr' ||
    maybeSettings.textDirection === 'rtl' ||
    maybeSettings.textDirection === 'auto'
      ? maybeSettings.textDirection
      : DEFAULT_DOCUMENT_EXPORT_SETTINGS.textDirection

  const fontSizePt =
    typeof maybeSettings.fontSizePt === 'number' &&
    Number.isFinite(maybeSettings.fontSizePt)
      ? maybeSettings.fontSizePt
      : DEFAULT_DOCUMENT_EXPORT_SETTINGS.fontSizePt

  return {
    textDirection,
    fontSizePt: Math.min(24, Math.max(8, Math.round(fontSizePt))),
  }
}
